import { HugeiconsIcon } from "@hugeicons/react";
import { MazeIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, cn } from "@workspace/frontend-ui";
import type { CSSProperties, FC } from "react";
import useKeyboardInset from "./hooks/useKeyboardInset";

type Props = {
  label: string;
  onClick?: () => void;
  isHidden: boolean;
};

const SurpriseMeButton: FC<Props> = ({ label, onClick, isHidden }) => {
  const keyboardInset = useKeyboardInset();

  return (
    <Button
      size="lg"
      onClick={onClick}
      style={{ "--keyboard-inset": `${keyboardInset}px` } as CSSProperties}
      className={cn(
        "max-md:fixed max-md:z-3 max-md:bottom-[calc(--spacing(6)+var(--keyboard-inset))] max-md:left-1/2 max-md:-translate-x-1/2 max-md:pb-[env(safe-area-inset-bottom)] max-md:transition-[bottom] max-md:duration-200 max-md:ease-out",
        isHidden && "max-md:hidden!",
      )}
      data-testid="search-surprise-me"
    >
      <HugeiconsIcon icon={MazeIcon} />
      {label}
    </Button>
  );
};

export default SurpriseMeButton;
